import styled, { css } from 'styled-components';
import { SplitButton } from 'primereact/splitbutton';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import {DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR, GRAY_FONT_COLOR, 
    SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX, TITLE_FONT_COLOR, X_LARGE_TEXT_PX, 
    X_SMALL_TEXT_PX, XX_SMALL_TEXT_PX,BLACK_FONT_COLOR,
    BLACK_FONT_COLOR2} 
    from '../../../styles/fonts/MCFontConstants';

export const NoSubTableDataDiv = styled.div`
    padding: 1rem;
    text-align: center;
    color: #666 ;
`;

export const PaginationButton = styled.div`
    position:${({ position }) => (position )} ;
    margin:${({ margin }) => (margin )}; 
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    margin-top: ${({ rightCOntentMarginTop }) => rightCOntentMarginTop? rightCOntentMarginTop : '0'}; 
`;

export const PageLink = styled.p.attrs(props => ({
    id: props.id
}))`
    position:${({ position }) => (position )} ;
    margin:${({ margin }) => (margin )};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer !important')};
    border-radius: 20px;
    margin-left: ${({ marginLeft }) => (marginLeft)};
    margin-right: ${({ marginRight }) => (marginRight)};
    cursor: pointer;
    width: ${({ width }) => (width)};
    height: 22px;
    text-align: center;
    font-size: ${SMALL_TEXT_PX};
    border: ${({ border }) => (border)};
    background: ${({ background }) => (background)};
    opacity: ${({ opacity }) => (opacity)};
    color: ${({ color }) => (color)};
    margin-bottom: 10px !important;
    margin-top: ${({ rightCOntentMarginTop }) => rightCOntentMarginTop ? 
        rightCOntentMarginTop : '0'} !important; 
`;

export const BottomText = styled.p`
    color: ${BLACK_FONT_COLOR};
    font-size: ${X_LARGE_TEXT_PX};
    margin-right: 15px;
`;
export const HeaderData = styled.div`
    font-family: AvenirNextWorld Regular;
    color: ${GRAY_FONT_COLOR};
    padding: 8px 0px 8px 0px;
`;

export const HeaderDiv = styled.div` 
    padding : ${(props) => props.padding};
`;

export const HeaderLeftBordered = styled.div`
    font-family: AvenirNextWorld Regular;
    color: ${GRAY_FONT_COLOR};
    border-left: ${(props) => props.borderLeft};
    width: 100%;
    height: 100%;
    padding: ${(props) => (props.padding ? props.padding : '2px 8px')};
    margin-left: ${(props) => (props.showScrollBar ? '-5px' : '')};
    ${media.smalDevice`
        margin-left: 0;
    `}
    ${media.mediumDevice`
        margin-left: 0;   
    `}
`;
export const UNiDContainer = styled.div`
    color: ${TITLE_FONT_COLOR};
    font-size: ${X_SMALL_TEXT_PX};
    font-family: AvenirNextWorld Regular;
    height: ${(props) => (props.height ? props.height : 'auto')};
    display: flex;
`;

export const UNiDText = styled.span`
    color: ${GRAY_FONT_COLOR};
    font-family: AvenirNextWorld Regular;
    margin-right: 2px;
`;

export const BodyContainer = styled.div`
    margin: 0;
    padding: 0 0 0 10px;
    border-left: 3px solid ${(props) => (props.color ? props.color : 'black')};
    height: ${(props) => (props.height ? props.height : '100%')};
    min-height: 100%;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .p-menu-overlay {
        display: none !important;
    }
    .p-menu {
        display: none !important;
    }
`;
export const DemiText = styled.p`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => color};
    font-size: ${(props) => (props.fontSize ? props.fontSize : SEMANTIC_TEXT_SMALL_PX)};
    font-weight: ${(props) => props.fontWeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
    ${media.mobileDevice`
    font-size: ${({ mbFontSize }) => mbFontSize};
    margin-bottom:${({ marginBottom }) => marginBottom};
    padding:${({ padding }) => padding};
    line-height: 20px;
    color: ${(props) => (props.color ? props.color : DARK_GRAY_FONT_COLOR)};
`}
`;
export const StatusText = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: ${X_SMALL_TEXT_PX};
    //width:77px;
    height: 22px;
    line-height: ${({ lineHeight }) => lineHeight};
`;
export const StatusFilterText = styled.div`
    @media only screen and (min-width: 768px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
    @media only screen and (min-width: 1024px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
`;
export const StatusFilterDiv = styled.div`
    @media only screen and (min-width: 768px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
    @media only screen and (min-width: 1024px) {
        height: ${(props) => (props.text ? '21px' : '13px')};
    }
`;

export const SmallHeaderText = styled.p`
    font-family: AvenirNextWorld Regular;
    font-size: ${XX_SMALL_TEXT_PX};
    line-height: ${({ lineHeight }) => lineHeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const BoldTruncatedItem = styled.p`
    font-family: AvenirNextWorld Demi;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    //width:125px;
    height: 21px;
    line-height: ${({ lineHeight }) => lineHeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const RegularText = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: ${(props) => (props.fontSize ? props.fontSize : SEMANTIC_TEXT_SMALL_PX)};
    color: ${(props) => (props.color ? props.color : BLACK_FONT_COLOR2)};
`;
export const AccountNameNumberText = styled(RegularText)`
    display: flex;
    flex-direction: ${({ flexDirection }) => flexDirection};
    ${media.mediumDevice`
        flex-direction: ${({ mdFlexDirection }) => mdFlexDirection};
        margin: ${({ mdMargin }) => mdMargin};
    `}
`;
export const RegularTruncateText = styled.div`
    font-family: AvenirNextWorld Regular;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props) => (props.fontSize ? props.fontSize : SEMANTIC_TEXT_SMALL_PX)};
    color: ${(props) => (props.color ? props.color : BLACK_FONT_COLOR2)};
    height: ${(props) => (props.height ? props.height : 'auto')};
    line-height: ${(props) => (props.lineHeight ? props.lineHeight : 'auto')};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const ProcedureTruncateText = styled.div`
    font-family: AvenirNextWorld Regular;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props) => (props.fontSize ? props.fontSize : SEMANTIC_TEXT_SMALL_PX)};
    color: ${(props) => (props.color ? props.color : BLACK_FONT_COLOR2)};
    height: ${(props) => (props.text ? '22px' : '16px')};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;
export const CaseRefText = styled.p`
    font-weight: bold;
    color: ${TITLE_FONT_COLOR};
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
    line-height: ${({ lineHeight }) => lineHeight};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;

export const SurgeryDateText = styled.div`
    padding-left: ${({ removePaddingLeft }) => removePaddingLeft ? '0' : '5px'};
    ${media.mediumDevice`
        font-size: ${({ mdFontSize }) => mdFontSize};
    `}
`;

export const PaginatorContainer = styled.div`
    & > div {
        background-color: transparent;
    }
    & > div > .p-paginator-current {
        flex: 1;
        justify-content: start;
    }
`;

export const DataTableContainer = styled.div`
    @media only screen and (max-width: 850px) and (orientation: landscape) {
        max-height: 150px !important;
        overflow-y: scroll !important;
    }
    .p-datatable-scrollable-header-box {
        margin-right: 0 !important;
    }
    .p-paginator-pages {
        padding-top: 5px;
        font-family: AvenirNextWorld Demi;
        display: flex;
        line-height: 22px;

        & > p {
            line-height: 22px;
        }
    }
    .p-datatable .p-datatable-tbody > tr > td {
        padding: ${({ padding }) => (padding ? padding : '2px')};
        font-size: ${SEMANTIC_TEXT_SMALL_PX};
        min-height: ${({ height }) => (height ? height : '87px')};
        height: ${({ height, isOrderHistory }) =>
            isOrderHistory ? 'auto' : height ? height : '87px'};
        border: ${({ border }) => (border ? border : 'none')};
    }

    /* Orders list Action column: allow an absolutely-positioned status line to span full row height */
    .p-datatable .p-datatable-tbody > tr > td.orders-action-cell {
        position: relative;
    }

    .p-datatable .p-datatable-scrollable-header {
        border-top-left-radius: 10px !important;
        border-top-right-radius: 10px !important;
    }

    .p-datatable .p-datatable-scrollable-body {
        max-height: calc(100vh - 22rem);
        border-bottom-left-radius: 10px !important;
        border-bottom-right-radius: 10px !important;
        ${scrollBarStyle}

        /* &::-webkit-scrollbar {
            display: ${({ showScrollBar }) =>
            showScrollBar ? 'block' : 'none'};
            width: 5px;
            border-radius: 25px;
        }
        &::-webkit-scrollbar-track {
            margin-top: 0px;
            border-radius: 25px;
        }
        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 25px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #555;
            border-radius: 25px;
        } */
        ${media.smalDevice`
        &::-webkit-scrollbar {
            display:  none;  
        }
        `}
        ${media.mediumDevice`
        &::-webkit-scrollbar {
            display:  none;    
        }
        `}
        
        @media only screen and (max-width: 1024px) and (orientation: landscape) {
            max-height: 110px !important;
        }  
    }

    .p-datatable .p-datatable-thead > tr > th {
        padding: 2px 2px 2px 4px;
    }

    .p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
        display: none;
    }

    .p-datatable {
        font-family: AvenirNextWorld Demi;
        color: ${GRAY_FONT_COLOR};
        border-radius: 6px;
    }

    .p-datatable-scrollable-wrapper {
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000029;
        border: 1px solid #dcdcdc;
        border-radius: 6px;
    }

    .p-datatable-thead {
        font-size: ${SEMANTIC_TEXT_SMALL_PX};
        background: #ffffff;
        box-shadow: 0px 1px 2px #00000029;
        border-bottom: ${({ headerBorderBottom }) =>
            headerBorderBottom ? headerBorderBottom : '2px solid #dcdcdc'};
        border-radius: 6px 6px 0px 0px;
    }

    .p-datatable .p-datatable-thead > tr > th {
        background-color: #ffffff;
    }

    .p-datatable .p-sortable-column.p-highlight {
        background: white;
        color: ${GRAY_FONT_COLOR};
        border: none;

        &:hover,
        :active {
            background: white;
            color: #3c3c3c;
            border: none;
        }
    }

    .pi:before {
        visibility: hidden;
    }

    .p-dropdown-trigger-icon.p-clickable.pi.pi-chevron-down:before {
        visibility: visible;
        font-size: 10px;
    }

    .p-dropdown-trigger-icon.p-clickable.pi.pi-chevron-down {
        padding-bottom: 5px;
    }

    .p-sortable-column .p-sortable-column-icon.pi-sort-amount-up-alt {
        content: url(${(props) => props.sortAscIcon});
        width: 12px;
        height: 12px;
    }

    .p-sortable-column .p-sortable-column-icon.pi-sort-amount-down {
        content: url(${(props) => props.sortDescIcon});
        width: 12px;
        height: 12px;
    }
    .p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd {
        background-color: ${({ backgroundColorOdd }) =>
            backgroundColorOdd ? backgroundColorOdd : '#f5f5f599'};
    }
    .p-datatable.p-datatable-striped .p-datatable-tbody > tr {
        background-color: ${({ backgroundColorEven }) =>
            backgroundColorEven ? backgroundColorEven : '#ffffffcc'};
    }

    p {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-bottom: 0;
    }

  .p-datatable .p-paginator-bottom {
        font-family: AvenirNextWorld Demi;
        line-height: 25px; 
        // box-shadow: 0;
        border: none;
        // padding: 18px 0 0 0;
        margin-top: ${({ marginTop }) => (marginTop ? marginTop : '10px')}; 
        /* height: 48px; */
        background: white;
        box-shadow: 0px -3px 6px #00000014;
        border-radius: 4px 4px 0px 0px;
        opacity: 1;
        ${media.smalDevice`
          margin-top:  ${({ ipadNoMarginTop }) => (ipadNoMarginTop ? '0' : '10px')};
        `}
    }
    .p-dropdown {
        width: 95%;
    }
    .p-dropdown-label.p-inputtext {
        font-family: AvenirNextWorld Regular;
        font-size: ${X_SMALL_TEXT_PX};
        padding-top: 2px;
        padding-bottom: 2px;
        color: ${DARK_NAVY_FONT_COLOR};
    }

    ${({ isListView }) =>
        isListView &&
        css`
            .p-datatable .p-sortable-column .p-column-title,
            .p-datatable .p-sortable-disabled .p-column-title {
                width: 60%;
                display: inline-block;
                line-height: 18px;
                height: auto;
                padding: 2px 0 0 0;
                vertical-align: top;
                margin: 0;
                ${media.smalDevice`{
                    display: ${({ displayType }) =>
                        displayType ? displayType : 'inline-block'};
                }`}
                ${media.mediumDevice`{
                    display: ${({ displayType }) =>
                        displayType ? displayType : 'inline-block'};
                }`} 
                @media (min-width: 768px) and (min-width: 850px) and (orientation: landscape) {
                    width: 70%;
                }   
            }

            .p-datatable .p-sortable-column .p-sortable-column-icon {
                padding: 4px 0 0 0;
                display: inline-block;
                vertical-align: top; 
            }
            
             
            .p-sortable-column .p-sortable-column-icon {
                margin: 2px;
                vertical-align: top;
                margin-left: ${(props) => props.sortMargin};
            }
                
            .p-datatable .p-sortable-column .p-sortable-column-icon.pi-fw {
                width: 1em !important;
            }
        `};
    .p-datatable .data-subtable {
        padding: 0;
    }

    ${({ showSubTable }) =>
        showSubTable &&
        css`
            .data-subtable .p-datatable .p-datatable-tbody {
                border-radius: 6px;
            }
        `};

    .data-subtable .p-datatable-thead {
        display: none;
    }

    .data-subtable .p-datatable table {
        width: ${({ subTableWidth }) =>
            subTableWidth ? subTableWidth : '95%'};
        margin: 0 auto;
        border: 1px solid #dcdcdc;
    }

    @media only screen and (min-width: 320px) and (max-width: 500px) and (orientation: landscape) {
        .p-datatable .p-datatable-scrollable-body {
            max-height: 110px !important;
        }
    }

    /* @media screen and (max-width: 850px) {
        .p-datatable.p-datatable-responsive .p-datatable-thead > tr > th {
            display: none !important;
        }

        .p-datatable.p-datatable-responsive .p-datatable-tfoot > tr > td {
            display: none !important;
        }

        .p-datatable.p-datatable-responsive .p-datatable-tbody > tr > td {
            text-align: left;
            display: block;
            border: 0 none !important;
            width: 100% !important;
            float: left;
            clear: left;
        }

        .p-datatable.p-datatable-responsive
            .p-datatable-tbody
            > tr
            > td
            .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4em 1em -0.4em -0.4rem;
            font-weight: bold;
        }
    } */
`;

export const StyledCasesCountFooter = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: ${SMALL_TEXT_PX};
    color: ${GRAY_FONT_COLOR};
    margin-bottom:${({ paginationLeftMarginBottom }) => (paginationLeftMarginBottom ? 
        paginationLeftMarginBottom : '0')};
`;
export const SplitButtonContainer = styled(SplitButton)`
    height: auto;
    width: 93%;
    margin-left: 0rem;
    outline: none;
    border: 1px solid #70707033 !important;
    border-radius: 4px;
    .p-button {
        color: #140f4b;
        background: #ffffff;
        padding: 2px 10px;
        font-size: ${X_SMALL_TEXT_PX};
        text-align: left;
        outline: none;
        border: 1px solid #ffffff !important;
    }
    .p-splitbutton {
        display: inline-flex;
        position: relative;
        width: 90%;
        border-radius: 4px;
    }
    .p-button:not(a):not(.p-disabled):active {
        background: #70707033 !important;
        color: ${TITLE_FONT_COLOR} !important;
        border-color: #70707033 !important;
        outline: none;
        border-color: #ffffff !important;
    }

    .p-button:not(a):not(.p-disabled):hover {
        background: #70707033 !important;
        color: ${DARK_NAVY_FONT_COLOR} !important;
        border-color: #70707033 !important;
        outline: none;
        border-color: #ffffff !important;
    }
    .p-button:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #f9f9f90d;
    }
    .p-button-label {
        font-family: AvenirNextWorld Regular;
        word-wrap: break-word;
    }

    .pi-chevron-down:before {
        visibility: visible;
        font-size: 12px;
        color: #3c3c3c;
    }
    .p-button-icon-only .p-button-label {
        visibility: visible;
        width: 0px;
        height: 0px;
    }
    .p-button.p-button-icon-only {
        border-left-color: #ffffff !important;
        width: 28px;
        height: auto;
        padding: 6px;
        display: ${({ display }) => (display ? display : '')};
    }
`;
